import React, {Component, PropTypes} from 'react'
// Services
import api from '../../../apiClient/v1'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
import { AutoSizer, Table, Column } from 'react-virtualized'
import { TablaOperario } from './TablaOperario.jsx'
import { EnrocarOperadores } from './EnrocarOperadores.jsx'
// Style
import classNames from 'classnames/bind'
import * as cssModal from './modal.css'
import * as css from './modal.css'
let cx = classNames.bind(cssModal)

export class ModalTrigger extends Component{
    constructor(props){
        super(props)
        this.state = { visible: false}
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalHistorial extends Component{
    constructor(props) {
        super(props)
        this.state = {
            detalle: []
        }
        this.fetchHistorial = ()=>{
            api.nomina(this.props.nomina.idNomina).historial()
             .then(historial=>{
             this.setState({detalle: historial})
             })
             .catch(meh=>{})
        }
    }
    componentWillMount() {
        this.fetchHistorial()
    }

    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalHistorialNomina')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <h4><span className="glyphicon glyphicon-list-alt"></span> Historial de nómina {this.props.nomina.cliente_nombreCorto} {this.props.nomina.local_numero}</h4>
                </Modal.Header>
                <Modal.Body>
                    <Historial
                        detalle={this.state.detalle}
                    />
                </Modal.Body>
            </Modal>
        )
    }
}

export class ModalAgregaOperador extends Component{
    constructor(props) {
        super(props)
        this.state = {
            operadores: [],
            operadoresFiltrados: [],
            busquedaRUN: '',
            busquedaNombre: '',
            busquedaComuna: ''
        }
        this.fetchOperadores = ()=>{
            this.context.getOperadoresDisponibles()
                .then(operadores=>{
                    this.setState({operadores}, this.filtrarUsuarios)
                })
                .catch(err=>{
                    console.log(err)
                })
        }
        this.realizarBusqueda = (campo, busquedaOriginal)=>{
            let newState = {}
            newState[campo] = busquedaOriginal.trim().toLowerCase()
            this.setState(newState, this.filtrarUsuarios)
        }
        this.filtrarUsuarios = ()=>{
            this.setState({
                operadoresFiltrados: this.state.operadores
                    .filter(us=> us.RUN.indexOf(this.state.busquedaRUN)>=0)
                    .filter(us=> us.nombre.toLowerCase().indexOf(this.state.busquedaNombre)>=0)
                    .filter(us=> us.comuna.toLowerCase().indexOf(this.state.busquedaComuna)>=0)
            })
        }
        this.agregaOperador = (titular, idCaptador, operarioRun)=>{
            this.context.agregarOperador(titular, idCaptador, operarioRun)
            this.props.hideModal()
        }
    }
    componentWillMount(){
        this.fetchOperadores()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalOperadoresDisponibles')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <h4><span className="glyphicon glyphicon-user"></span> Operadores Disponibles</h4>
                </Modal.Header>
                <Modal.Body>
                        <TablaOperario
                            operarios={this.state.operadoresFiltrados}
                            agregaOperador={this.agregaOperador}
                            // busqueda
                            busquedaRUN={this.state.busquedaRUN}
                            realizarBusquedaRUN={this.realizarBusqueda.bind(this, 'busquedaRUN')}
                            busquedaNombre={this.state.busquedaNombre}
                            realizarBusquedaNombre={this.realizarBusqueda.bind(this, 'busquedaNombre')}
                            busquedaComuna={this.state.busquedaComuna}
                            realizarBusquedaComuna={this.realizarBusqueda.bind(this, 'busquedaComuna')}
                        />
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12">
                        <button className="btn btn-md btn-cancel pull-right" onClick={this.props.hideModal}>Cancelar</button>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}
export class ModalEnrocarOperadores extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false,
            mensaje: "",
            letra: "",
            panelConteo: "",
            nivelConteo: -1
        }
        this.confirmar = ()=>{
            this.setState({bloqueado: true})
            let arrayT = []
            let arrayR = []
            this.props.titulares.forEach(titular => arrayT.push(titular.id))
            this.props.reemplazos.forEach(reemplazo => arrayR.push(reemplazo.id))
            this.props.enrocarOperadores(arrayT, arrayR)
            this.props.cancelarEnroque()
                /*.then((nomina)=>{
                    console.log('worked')
                    this.setState({bloqueado: false, nomina})
                    this.props.hideModal()
                })
                .catch(err=>{
                    console.error(err.data)
                })*/
        }

        this.volver = () => {
            this.props.hideModal()
        }

        this.actualizarEstadisticas = (titulares, reemplazos) => {
            api.nomina(this.props.idNomina).actualizarEstadisticas(titulares, reemplazos)
                .then((response)=>{
                    this.setState({
                        panelConteo: response.panelConteo, 
                        mensaje: response.mensaje,
                        letra: response.letra,
                        nivelConteo: response.nivelConteo})
                    //this.props.hideModal()
                })
                .catch(err=>{
                    console.error(err.data)
                })
        }
    }
    componentDidMount(){
       this.actualizarEstadisticas(this.props.titulares, this.props.reemplazos)
    }
    render() {
        //console.log(this.props.titulares)
        if ((this.props.titulares.length == this.props.reemplazos.length) && (this.props.titulares.length != 0)) {
            return (
                <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalConfirmacion')} className={cx('modale')}>
                    <Modal.Header closeButton>
                        <Modal.Title>Favor confirmar el cambio de operadores</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <EnrocarOperadores
                            //arraytitular={arraytitular}
                            //arrayreemplazo={arrayreemplazo}
                            titulares={this.props.titulares}
                            reemplazos={this.props.reemplazos}
                            letra={this.state.letra}
                            panelConteo={this.state.panelConteo}
                            enrocarOperadores={this.props.enrocarOperadores}
                            mensaje={this.state.mensaje}
                            sumaUnidades={this.props.sumaUnidades}
                            stock={this.props.stock}
                            >
                        </EnrocarOperadores>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.state.nivelConteo != -1 ? (this.state.nivelConteo >= 2  ? <button type="button" className="btn btn-primary" onClick={this.confirmar} disabled={this.state.bloqueado}>Agregar</button> : (<div><p style={{textAlign: 'center', marginTop: '10px', fontSize: '20px'}}>PORCENTAJE CONTEO SUGERIDO DEBE SER MAYOR (86% HACIA ARRIBA)</p> <button type="button" className="btn btn-primary" onClick={this.volver} disabled={this.state.bloqueado}>VOLVER</button> </div>)) : <button type="button" className="btn btn-primary" style={{visibility: 'hidden'}} onClick={this.confirmar} disabled={this.state.bloqueado}>Agregar</button>}
                    </Modal.Footer>
                </Modal>
            )
        }else{
            return (
                <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalConfirmacion')} className={cx('modale')}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error al intentar enrocar operadores</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{textAlign: 'center'}}>POR FAVOR DEBE SELECCIONAR LA MISMA CANTIDAD DE OPERADORES (TITULARES Y REEMPLAZOS) Y LA CANTIDAD DEBE SER MAYOR A 0</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-primary" onClick={this.volver} disabled={this.state.bloqueado}>VOLVER</button>
                    </Modal.Footer>
                </Modal>
            )
        }
    }
}

export class ModalOperadorEscondido extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.confirmar = ()=>{
            this.props.setEscondido(this.props.id)
            this.props.hideModal()
        }

        this.volver = () => {
            this.props.hideModal()
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalConfirmacion')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Operador escondido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{textAlign: 'center', fontSize: 'xl'}}>¿Desea mandar a {this.props.operador} como operador escondido?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={this.confirmar}>Confirmar</button>
                    <button type="button" className="btn btn-primary" onClick={this.volver}>VOLVER</button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export class ModalReemplazoPorBaja extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.confirmar = ()=>{
            this.props.cambiarPanel(this.props.id, false, this.props.captador)
            this.props.hideModal()
        }

        this.volver = () => {
            this.props.hideModal()
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalConfirmacion')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Operador de reemplazo por baja</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{textAlign: 'center', fontSize: 'xl'}}>¿Desea de titular a {this.props.operador}? El operador tendrá un máximo de 30 minutos a partir de la APROBACIÓN DE LA NÓMINA para aceptar el proceso, sino será quitado de titular.</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={this.confirmar}>Confirmar</button>
                    <button type="button" className="btn btn-danger" onClick={this.volver}>Cancelar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export class ModalReemplazoCaptador extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            estadoCaptador: null,
            captadores: []
        }
        this.confirmar = ()=>{
            this.props.cambiarPanel(this.props.id, false, this.state.estadoCaptador)
            this.props.cambiarCaptador(this.props.id, this.state.estadoCaptador)
            this.props.hideModal()
        }

        this.sei = () => {
            this.props.cambiarPanel(this.props.id, false, 1)
            this.props.hideModal()
        }
    }

    componentDidMount() {
        fetch('/api/get-captadores')
            .then(response => response.json())
            .then(data => {
                const datos = data.filter((item) => item.id != 658 && item.id != 1);
                this.setState({ captadores: datos });
            })
            .catch(error => console.error('Error cargando captadores:', error));
    }

    handleSelectChange = (event) => {
        this.setState({ estadoCaptador: event.target.value });
    };

    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalConfirmacion')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Captador operador</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ textAlign: 'center', fontSize: 'xl' }}>
                        ¿Desea cambiarle el captador al operador {this.props.operador}?
                    </p>
                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                        <select className="form-control" onChange={this.handleSelectChange} value={this.state.estadoCaptador || ''} size={6}>
                            <option value={0}>Seleccione un captador</option>
                            {this.state.captadores.length > 0 ? this.state.captadores.map(captador => (
                                <option key={captador.id} value={captador.id}>{captador.nombre1} {captador.apellidoPaterno}</option>
                            )) : null}
                        </select>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={this.confirmar} disabled={!this.state.estadoCaptador || this.state.estadoCaptador == 0}>Cambiar</button>
                    <button type="button" className="btn btn-danger" onClick={this.sei}>Mantener SEI</button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export class ModalPendientesRegion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            loading: false,
            refresh: false,
        }

        this.fetchData = () => {
            this.setState({loading: true})
            api.nomina(this.props.idNomina).operadoresPendientesRegion()
                .then((response) => {
                    this.setState({ data: response, loading: false });
                })
                .catch((error) => {
                    console.error('Error al cargar los datos:', error);
                    this.setState({loading: false})
                });
        };

        this.handleRefresh = () => {
            this.setState({ refresh: true })
            api.nomina(this.props.idNomina).operadoresPendientesRegion()
                .then((response) => {
                    this.setState({ refresh: false, data: response });
                })
                .catch((error) => {
                    console.error('Error al cargar los datos:', error);
                    this.setState({ refresh: false })
                });
        }
        
        this.pasarAReemplazo = (idUser, idCaptador) => {
            let nuevaData = Object.values(this.state.data).filter(op => op.id !== idUser);
            this.props.cambiarDePanel(idUser, true, idCaptador, true)
                .then((response) => {
                    this.setState({ data: nuevaData });
                    this.props.notificator.success("Nómina", "Usuario agregado correctamente", 4 * 1000);
                })
                .catch((error) => {
                    //console.log(error)
                    this.props.notificator.error("Error al agregar el operador", error.data.usuarioRUN, 4 * 1000);
                });
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.fetchData();
        }
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.hideModal} bsSize='large' dialogClassName='custom-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Operadores pendientes dentro de la región 
                        {this.state.loading ? null : <button className='btn btn-primary' style={{margin: '5px'}} disabled={this.state.refresh} onClick={() => this.handleRefresh()}>
                            <span className='glyphicon glyphicon-refresh'></span>
                        </button>}
                        {this.state.refresh && "Actualizando..."}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ textAlign: 'center', marginTop: '10px', overflowY: 'auto', maxHeight: '70%'}}>
                        {this.state.loading ? <p style={{fontSize: "large"}}>Cargando...</p> : 
                        <table className='table table-condensed' style={{overflowY: 'hidden'}}>
                            <thead style={{position: 'sticky', top: '0', backgroundColor: 'white'}}>
                                <tr>
                                    <th>#</th>
                                    <th style={{textAlign: 'center'}}>RUT</th>
                                    <th style={{textAlign: 'center'}}>Nombre</th>
                                    <th style={{textAlign: 'center'}}>Comuna</th>
                                    <th style={{textAlign: 'center'}}>Captador</th>
                                    <th style={{textAlign: 'center'}}>Exp.</th>
                                    <th style={{textAlign: 'center'}}>Error</th>
                                    <th style={{textAlign: 'center'}}>Sug.</th>
                                    <th style={{textAlign: 'center'}}>Real</th>
                                    <th style={{textAlign: 'center'}}>Último</th>
                                    <th style={{textAlign: 'center'}}>Ctto.</th>
                                    <th style={{textAlign: 'center'}}></th>
                                    <th style={{textAlign: 'center'}}></th>
                                </tr>
                            </thead>
                            <tbody style={{overflowY: 'hidden'}}>
                                {this.state.data && Object.values(this.state.data).length > 0 ? Object.values(this.state.data).map((dato,index) => {
                                    const colorContrato = dato.idEstadoContrato == 2 && dato.isValido == 1 ? "rgb(95, 228, 255)" : (dato.idEstadoContrato == 2 ? "rgba(98, 251, 141, 0.835)" : (dato.idEstadoContrato == 1 ? "rgb(248, 87, 62)" : "rgb(252, 166, 135)"))
                                    return <tr style={{fontSize: '13px'}} key={index}>
                                        <td style={{textAlign: 'center', verticalAlign: 'middle'}}>{index + 1}</td>
                                        <td style={{textAlign: 'left', verticalAlign: 'middle'}}>{dato.usuarioRUN + "-" + dato.usuarioDV}</td>
                                        <td style={{textAlign: 'left', verticalAlign: 'middle'}}>{dato.nombreCorto}</td>
                                        <td style={{textAlign: 'left', verticalAlign: 'middle'}}>{dato.comuna}</td>
                                        <td style={{textAlign: 'left', verticalAlign: 'middle'}}>{dato.captador}</td>
                                        <td style={{textAlign: 'right', verticalAlign: 'middle'}}>{dato.experienciaComoOperador.toLocaleString('es-CL')}</td>
                                        <td style={{textAlign: 'right', verticalAlign: 'middle'}}>{dato.error}</td>
                                        <td style={{textAlign: 'right', verticalAlign: 'middle'}}>{dato.unidadesContadas.toLocaleString('es-CL')}</td>
                                        <td style={{textAlign: 'right', verticalAlign: 'middle'}}>{dato.unidadesContadasReal.toLocaleString('es-CL')}</td>
                                        <td style={{textAlign: 'right', whiteSpace: 'nowrap', verticalAlign: 'middle'}}>{dato.ultimo_inventario}</td>
                                        <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                            <div style={{borderRadius: '50px', backgroundColor: colorContrato, textAlign: 'center', margin: 'auto', minWidth: '8px', minHeight: '12px', width: '40%'}}>
                                            </div>
                                        </td>
                                        <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                            <button className='btn btn-info' title='Asignar a reemplazo' onClick={() => this.pasarAReemplazo(dato.id, dato.idCaptador)}>
                                                <span className='glyphicon glyphicon-list-alt'></span>
                                            </button>
                                        </td>
                                    </tr>
                                }) : <tr style={{padding: '6px'}}>
                                    <td colSpan={13} style={{textAlign: 'center', verticalAlign: 'middle'}}>No se encontraron registros.</td>
                                    </tr>}
                            </tbody>
                            {/* {viendoPasaje && <ModalArchivo hideModal={onClickPasaje} viendoPasaje={viendoPasaje} ruta={rutaArchivo} />} */}
                        </table>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* <button className="btn btn-success" onClick={this.confirmar} disabled={!this.state.estadoCaptador || this.state.estadoCaptador == 0}>Cambiar</button>
                    <button type="button" className="btn btn-danger" onClick={this.sei}>Mantener SEI</button> */}
                </Modal.Footer>
            </Modal>
        )
    }
}

ModalAgregaOperador.contextTypes = {
    getOperadoresDisponibles: PropTypes.func,
    agregarOperador: PropTypes.func
}

const Historial = ({detalle})=>
    <div style={{height: '40%'}} className="row">
        <AutoSizer>
            {({height, width}) =>
                <Table
                    // general
                    height={height}
                    width={width}
                    // headers
                    headerHeight={30}
                    headerClassName={css.headerColumn}
                    // rows
                    rowCount={detalle.length}
                    rowGetter={({index})=> detalle[index]}
                    rowHeight={30}
                    rowClassName={({index})=> index<0? css.headerRow : ((index%2===0)? css.evenRow : css.oddRow)}
                >
                    {/* TITULO */}
                    <Column
                        dataKey='titulo' label="TITULO"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={210}
                    />
                    {/* TEXTO */}
                    <Column
                        dataKey='texto' label="DESCRIPCION"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                        width={650}
                    />
                    {/* FECHA */}
                    <Column
                        dataKey='created_at' label="FECHA EVENTO"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                        width={200}
                    />
                </Table>
            }
        </AutoSizer>
    </div>

export class ModalMasTiempo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        const { mas_tiempo = [] } = this.props;
        return (
            <Modal
                show={true}
                onHide={this.props.hideModal}
                dialogClassName={cx('modalConfirmacion')}
                className={cx('modale')}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Más Tiempo de Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ textAlign: 'center', fontSize: '18px' }}>
                        Seleccione la acción para cada operador:
                    </p>
                    <div style={{ marginTop: '15px' }}>
                        {mas_tiempo.length === 0 ? (
                            <p style={{ textAlign: "center" }}>No hay operadores disponibles.</p>
                        ) : (
                            <ul className="list-group">
                                {mas_tiempo.map((persona) => (
                                    <li
                                        key={persona.id}
                                        className="list-group-item"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                    >
                                        <span>
                                            {persona.nombre}
                                        </span>
                                        <div>
                                            <button
                                                className="btn btn-success btn-sm"
                                                style={{ marginRight: "8px" }}
                                                onClick={() => this.props.handleMasTiempo(persona.id, true)}
                                            >
                                                <span className="glyphicon glyphicon-time"></span> 15 min.    
                                            </button>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => this.props.handleMasTiempo(persona.id, false)}
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={this.props.hideModal}>
                        Cerrar
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/components/Modales.jsx